import React, { ReactNode } from 'react';

interface FeatureItemProps {
  icon: ReactNode;
  label: string;
}

const FeatureItem: React.FC<FeatureItemProps> = ({ icon, label }) => (
  <div className="flex items-center gap-4">
    <div className="rounded-lg bg-gradient-to-br from-primary to-[#0A368E] p-2">
      {icon}
    </div>
    <div className="font-semibold">{label}</div>
  </div>
);

export default FeatureItem;
